import React, { PureComponent } from 'react';
import { Icon } from 'semantic-ui-react';
import classes from './InjuryStatus.css';


export default class InjuryStatus extends PureComponent {
  static defaultProps = {
    printable: false,
  }
  render() {
    /*
    // comment this out to hide injury main icon
    return (
      <div className={this.props.printable ? classes.printableInjuryStatus : classes.injuryStatus}>
        <Icon name="plus" size="large" className={this.props.printable ? classes.printableInjuryStatusIcon : classes.injuryStatusIcon} />
        <span> = Injury Status</span>
      </div>
    );
    */
   return (<div></div>);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/TableControls/InjuryStatus/InjuryStatus.js